import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const RefrigeratedAirDryerIcon = ({
  width = 19,
  height = 21,
  color,
  ...rest
}: {
  width?: number;
  height?: number;
  color?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M18.1172 20.709H0V9.74707H18.1172V20.709ZM18.1172 8.52539H0V0H18.1172V8.52539ZM13.8545 1.8291C12.5092 1.82921 11.4189 2.92034 11.4189 4.26562C11.4192 5.61069 12.5094 6.70106 13.8545 6.70117C15.1996 6.70105 16.2908 5.61069 16.291 4.26562C16.291 2.92034 15.1997 1.82923 13.8545 1.8291Z"
        fill={currentColor}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default RefrigeratedAirDryerIcon;
